/**
 * Asynchronously loads the component for SketchToImage
 */

import React from 'react'
import loadable from 'utils/Loadable'
import { LoadingPage } from 'components/Loading'

export default loadable(() => import(/* webpackChunkName: "SketchToImagePage" */ './index'), {
  fallback: <LoadingPage />
})
